/**
 * 所有公开可用的事件名定义
 * All public event names
 * names should be like 'namespace.modelName.whatHappened'
 *
 */
// eslint-disable-next-line no-shadow
export enum IPublicEnumEventNames {
}